import React from 'react';
import { Switch } from 'react-router';
import { Auth } from '@leverege/api-redux';
import { Content, Pane } from '@leverege/ui-elements';
import { TitleBar, Toolbar, createConnect } from '@leverege/ui-plugin';
import { UI } from '@leverege/ui-redux';
import { History } from '@leverege/molten-core';
import { Routes } from "../../routes/index.js";
import NetworkOffline from "../../views/NetworkOffline.js";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const matchContext = {
  use: 'navBar',
  client: 'Main'
};
const userMatchContext = {
  use: 'userBar',
  client: 'Main'
};
class MainScreen extends React.PureComponent {
  getContext() {
    const {
      profile,
      username
    } = this.props;
    return {
      client: 'Main',
      clientProps: this.props,
      profile,
      username
    };
  }
  onHome = evt => {
    const {
      dispatch
    } = this.props;
    dispatch(History.push('/'));
  };
  render() {
    const {
      navIconOverride,
      navTitleVariantOverride
    } = this.props;
    const cxt = this.getContext();

    // if ( this.lastProps ) {
    //   const diff = Object.keys( this.props ).filter( (key) => { return this.lastProps[key] !== this.props[key] })
    //   console.log( 'Main Diffs', diff )
    // }
    // this.lastProps = this.props

    return /*#__PURE__*/_jsxs(Content, {
      style: {
        zIndex: 0
      },
      variant: "mainScreen",
      children: [/*#__PURE__*/_jsxs(Content.Header, {
        variant: "mainScreenHeader",
        children: [/*#__PURE__*/_jsxs(TitleBar, {
          variant: "topNav",
          titleVariant: navTitleVariantOverride,
          icon: navIconOverride,
          onClick: this.onHome,
          children: [/*#__PURE__*/_jsx(Toolbar, {
            variant: "topNavBar",
            matchContext: matchContext,
            context: cxt
          }), /*#__PURE__*/_jsx(Toolbar, {
            variant: "userTopNavBar|topNavBar",
            matchContext: userMatchContext,
            context: cxt
          })]
        }), /*#__PURE__*/_jsx(Pane, {
          variant: "topNavBreadcrumbs",
          children: Routes.getRoutesFor('Main', 'Breadcrumbs', {
            client: 'Breadcrumbs'
          }, null, false)
        }), /*#__PURE__*/_jsx(NetworkOffline, {})]
      }), /*#__PURE__*/_jsx(Content.Area, {
        variant: "mainScreenContent",
        children: /*#__PURE__*/_jsx(Switch, {
          children: Routes.getRoutesFor('Main', null, {
            client: 'Main'
          })
        })
      })]
    });
  }
}
const connect = createConnect('Main', {
  client: 'Main'
});
export default connect(state => {
  return {
    profile: Auth.getProfile(state.auth),
    username: Auth.getUsername(state.auth),
    navIconOverride: UI.get(state, 'molten.navIconOverride'),
    navTitleVariantOverride: UI.get(state, 'molten.navTitleVariantOverride') || 'navLogo'
  };
})(MainScreen);